import type { SelectedSaleDocument } from './selectedSales';

export interface PackingSlip {
  sender?: { name: string; address: string; phone: string };
  shipment?: { stage: string; courier: string | null; tracking: string | null };
  id: string;
  number: string;
  date: string;
  status: string;
  subtotal: number;
  discount: number;
  deliveryCharge: number;
  total: number;
  recipient: { name: string | null; phone: string | null; address: string | null };
  items: Array<{
    id: string;
    name: string;
    size: string | null;
    color: string | null;
    quantity: number;
    returnedQuantity: number;
    unitPrice: number;
    discount: number;
    total: number;
  }>;
}

/** Explicit courier allowlist: selling prices only, without costs, payments or internal notes. */
export function buildPackingSlips(sales: readonly SelectedSaleDocument[]): PackingSlip[] {
  return sales.map((sale) => ({
    id: sale.id,
    number: sale.number,
    date: sale.date,
    status: sale.orderStatus,
    subtotal: sale.items.reduce((sum, item) => sum + item.unitPrice * item.quantity, 0),
    discount: sale.items.reduce((sum, item) => sum + item.discount, 0),
    deliveryCharge: sale.deliveryCharge,
    total: sale.total,
    recipient: { name: sale.customerName, phone: sale.phone, address: sale.address },
    items: sale.items.map((item) => ({
      id: item.id,
      name: item.name,
      size: item.size,
      color: item.color,
      quantity: item.quantity,
      returnedQuantity: item.returnedQuantity,
      unitPrice: item.unitPrice,
      discount: item.discount,
      total: item.total,
    })),
  }));
}
